import { render, staticRenderFns } from "./Notification.vue?vue&type=template&id=1332bbb8&scoped=true"
import script from "./Notification.vue?vue&type=script&lang=ts"
export * from "./Notification.vue?vue&type=script&lang=ts"
import style0 from "./Notification.vue?vue&type=style&index=0&id=1332bbb8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../DATA/projects/nguonhangchina/client/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1332bbb8",
  null
  
)

export default component.exports